import type { SupplierProductGetResponseType } from "@sellar-io/api-v2/types";

export type ProductItemDialogPagesType = {
  PRODUCT_DETAILS: number;
  PRODUCT_PRICING: number;
};

export interface ProductItemDetailsDialogType extends Pick<
  SupplierProductGetResponseType,
  | "vegan"
  | "lactoseFree"
  | "glutenFree"
  | "containerType"
  | "unit"
  | "packQuantity"
  | "weight"
  | "volume"
  | "sku"
  | "id"
> {
  Parent: Pick<
    SupplierProductGetResponseType,
    "vegan" | "lactoseFree" | "glutenFree" | "id" | "active"
  > | null;
}

export const ProductItemDialogPages: ProductItemDialogPagesType = {
  PRODUCT_DETAILS: 0,
  PRODUCT_PRICING: 1,
};
